export default "__VITE_ASSET__aa94fe5b__"